import {API_URL} from "../../dev";

import "isomorphic-fetch";

class PaymentApi {
	async createPaymentResource(merchantId, themeName, shoppingCartSecureId) {
		try {
			const response = await fetch(
				`${API_URL}/v1/paypal/${merchantId}_${themeName}/paymentresource`, {
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ shoppingcartSecureId: shoppingCartSecureId }),
				});
			const obj = await response.json();
			if (response.ok) {
				return obj;
			}
			throw obj;
		} catch (e) {
			console.error(`Error occurred in createPaymentResource: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async reset(payload, mercIds) {
		try {
			return await fetch(
				`${API_URL}/v1/checkout/${mercIds.merchantId}_${mercIds.themeName}/reset`, {
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(payload),
				});
		} catch (e) {
			console.error(`Error occurred in CHECKOUT reset: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async next(payload, mercIds) {
		try {
			const response = await fetch(
				`${API_URL}/v1/checkout/${mercIds.merchantId}_${mercIds.themeName}/next`, {
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(payload),
				});
			const obj = await response.json();
			if (response.ok) {
				return obj.state;
			}
			throw obj;
		} catch (e) {
			console.error(`Error occurred in CHECKOUT next: ${JSON.stringify(e)}`);
			throw e;
		}
	}

	async pop(payload, mercIds) {
		try {
			const response =  await fetch(
				`${API_URL}/v1/checkout/${mercIds.merchantId}_${mercIds.themeName}/pop`, {
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(payload),
				});
			const obj = await response.json();
			if (response.ok) {
				return obj;
			}
			throw obj;
		} catch (e) {
			console.error(`Error occurred in CHECKOUT pop: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}
const paymentApi = new PaymentApi();
export default paymentApi;
